// extracted by mini-css-extract-plugin
export default {"Link":"ContactsBlock_Link__ws4W2","SupportPhone":"ContactsBlock_SupportPhone__oD-SH","SocialLink":"ContactsBlock_SocialLink__nu0Nx","MapImage":"ContactsBlock_MapImage__w6dxR"};